import * as React from 'react'

import { Box, Section } from '@factorialco/deprecated-design-system'
import { Features } from 'generated/featureDefinitions'

import i18n from 'modules/core/lib/i18n'

import AllowEndless from 'modules/timeoff/components/LeaveTypeSettings/LeaveTypes/UpsertLeaveType/Content/AllowEndless'
import DaysUnits from 'modules/timeoff/components/LeaveTypeSettings/LeaveTypes/UpsertLeaveType/Content/DaysUnits'
import HalfDaysUnitsEnabled from 'modules/timeoff/components/LeaveTypeSettings/LeaveTypes/UpsertLeaveType/Content/HalfDaysUnitsEnabled'
import { useFeature } from 'modules/timeoff/hooks/useFeature'
import type LeaveTypeFormModel from 'modules/timeoff/lib/LeaveTypeForm'

interface Props {
  leaveTypeForm: LeaveTypeFormModel
  canEditDetails: boolean
}

const DurationSection = ({ leaveTypeForm, canEditDetails }: Props) => {
  const { loading, enabled: absenceDurationControlEnabled } = useFeature(
    Features.timeoff_absence_duration_control
  )

  const handleHalfDayUnitChange = (value: boolean) => {
    leaveTypeForm.setValues({ half_days_units_enabled: value })
  }

  const handleAllowEndlessChange = (value: boolean) => {
    leaveTypeForm.setValues({ allow_endless: !value })
  }

  return loading ? (
    <></>
  ) : (
    <Section
      illustration="calendar-clock"
      title={i18n.t('settings.leave_types.page.duration.title')}
      description={i18n.t('settings.leave_types.page.duration.description')}
    >
      <Box gap="s24">
        {absenceDurationControlEnabled && (
          <HalfDaysUnitsEnabled
            field={leaveTypeForm.get('half_days_units_enabled')}
            onChange={handleHalfDayUnitChange}
          />
        )}
        <AllowEndless
          readonly={!canEditDetails}
          field={leaveTypeForm.get('allow_endless')}
          onChange={handleAllowEndlessChange}
        />
        {absenceDurationControlEnabled && <DaysUnits leaveTypeForm={leaveTypeForm} />}
      </Box>
    </Section>
  )
}

export default DurationSection
